import { isMusicPlatformUrl } from './urlUtils';

export const LINKS_NOT_SUPPORTED_MESSAGE = "Links aren't supported here. Type the song name instead.";

const LINK_PREFIX_PATTERN = /^(https?:\/\/|www\.)/i;
const SCHEMELESS_MUSIC_HOST_PATTERN = /^(open\.spotify\.com|music\.apple\.com|spotify\.link|youtu\.be|youtube\.com|music\.youtube\.com|tidal\.com|deezer\.com|music\.amazon\.com)\//i;

export function looksLikeLink(text: string): boolean {
  const trimmed = text.trim();
  if (!trimmed) return false;
  if (LINK_PREFIX_PATTERN.test(trimmed)) return true;
  if (isMusicPlatformUrl(trimmed)) return true;
  return SCHEMELESS_MUSIC_HOST_PATTERN.test(trimmed);
}
